import { ReactNode } from 'react';

import { AnimatePresence, LayoutGroup } from 'framer-motion';

import { ParentAnimation } from '../animation/parent';

export const TabContent = <TOption extends string>({
  tab,
  tabs,
}: {
  tab: TOption;
  tabs: Record<TOption, ReactNode>;
}) => {
  const tabContent = tabs[tab];
  return (
    <LayoutGroup>
      <AnimatePresence>
        <ParentAnimation key={tab} w='100%' mx='auto' exit={undefined}>
          {tabContent}
        </ParentAnimation>
      </AnimatePresence>
    </LayoutGroup>
  );
};
